export default "__VITE_ASSET__CHR6YmdT__"